import Vue from 'vue';
import Router from 'vue-router';

import Vacancies from '@/components/pages/Vacancies/Vacancies';
import OpenApplication from '@/components/pages/OpenApplications/OpenApplication';
import VacancyApplication from '@/components/pages/VacancyApplications/VacancyApplication';

Vue.use(Router);

export default new Router({
    routes: [
        {path: '*', name: 'all', component: Vacancies, meta: {}},
        {path: '/vacancies', name: 'vacancies', component: Vacancies, meta: {}},
        {path: '/open-application/:token', name: 'openApplication', component: OpenApplication, meta: {}},
        {
            path: '/open-application/:token/:seafarerId',
            name: 'openApplicationExistingSeafarer',
            component: OpenApplication,
            meta: {},
        },
        {
            path: '/vacancy-application/:token/:vacancyId',
            name: 'vacancyApplication',
            component: VacancyApplication,
            meta: {},
        },
        {
            path: '/vacancy-application/:token/:vacancyId/:seafarerId',
            name: 'vacancyApplicationExistingSeafarer',
            component: VacancyApplication,
            meta: {},
        },
    ],
});
